import { render } from "./RatingResult.vue?vue&type=template&id=5bb49d2c"
import script from "./RatingResult.vue?vue&type=script&lang=js"
export * from "./RatingResult.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__